import Button from "../Common/Buttons";
import { PictogramIcon } from "../Common/Icon";
import "./MessageAttachmentPreview.css";
import { Flex } from "../Common/Flex";
import Label from "../Common/Label";

type Props = {
    title?: string | undefined | null;
    subtitle?: string | undefined | null;
    image?: string | undefined | null;
    imageIcon?: React.JSX.Element | undefined | null;
    pictogram?: React.JSX.Element | undefined | null;
    onClick?: () => void;
    onRemove?: () => void;
    children?: React.ReactNode;
};

function MessageAttachmentPreview(props: Props) {
    const {
        title,
        subtitle,
        image,
        imageIcon,
        pictogram,
        children,
        onClick,
        onRemove,
    } = props;

    const imageThumbnail = image ? (
        <span className="message-attachment-preview__absolute-icon">
            <img
                src={image}
                alt="attachment"
                className="message-attachment-preview__image"
            />
            {imageIcon}
        </span>
    ) : null;

    const content = (
        <Flex.Row gap="medium">
            {pictogram || imageThumbnail}
            {(title || subtitle) && (
                <Flex.Column gap="xsmall" className="message-attachment-preview__title">
                    {title && <h5>{title}</h5>}
                    {subtitle && <Label.Small.N50>{subtitle}</Label.Small.N50>}
                </Flex.Column>
            )}
            {children}
        </Flex.Row>
    );
    return (
        <div className="message-attachment-preview">
            {onClick ? (
                <Button.Ghost onClick={onClick}>{content}</Button.Ghost>
            ) : (
                <div>{content}</div>
            )}
            {onRemove && (
                <Button.Ghost
                    className="message-attachment-preview__remove"
                    onClick={onRemove}
                >
                    <PictogramIcon.Close.Small.N90 />
                </Button.Ghost>
            )}
        </div>
    );
}

export default MessageAttachmentPreview;
